<template>
  <div class="input-action-status">
    <template v-if="displayState === StatusDisplayState.itemDetails">
      <OrderItems :key="'action-status-' + input.id.toString()" :input="input" @submit="done()" @back="goBack">
        <StepTitle hr>
          <div class="how-can">Select Items for Status</div>
        </StepTitle>
      </OrderItems>
    </template>
    <template v-else>
      <SessionContent></SessionContent>
      <b-row class="justify-content-center boxes" v-if="canGoBack || isLastItem || !session.enhanced_mode">
        <b-col v-if="canGoBack" cols="10" sm="6" md="4" lg="3" class="mb-2">
          <b-button block @click="goBack()" variant="outline-primary btn-outline-success" class="btn-back">Back</b-button>
        </b-col>
        <b-col v-if="isLastItem" cols="10" sm="6" md="4" lg="3" class="mb-2">
          <b-button block @click="setDisplayState(StatusDisplayState.itemDetails)" variant="primary" class="btn-account">View Details</b-button>
        </b-col>
        <b-col v-if="isLastItem || !session.enhanced_mode" cols="10" sm="6" md="4" lg="3" class="mb-2">
          <b-button block @click="done()" variant="primary" class="btn-account">
            <span class="inline-button-label" v-html="input.formatted_label"></span>&nbsp;
            <font-awesome-icon :icon="['fas', 'caret-right']" class="footer_btn"></font-awesome-icon>
          </b-button>
        </b-col>
        <b-col v-if="returnLabelText" cols="10" sm="6" md="4" lg="3" class="mb-2">
          <b-button block @click="getShipmentReturnLabel(false)" variant="primary" class="btn-account" v-html="returnLabelText"></b-button>
        </b-col>
        <b-col v-if="returnQRCodeText" cols="10" sm="6" md="4" lg="3" class="mb-2">
          <b-button block @click="getShipmentReturnLabel(true)" variant="primary" class="btn-account" v-html="returnQRCodeText"></b-button>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {InputType} from '@/constants'
const StepTitle = () => import('./StepTitle')
const SessionContent = () => import('./SessionContent')
const OrderItems = () => import('@/components/OrderItems')

const StatusDisplayState = Object.freeze({
  status: 0,
  itemDetails: 1,
  destroyed: 2
})

export default {
  name: 'InputActionStatus',
  components: {
    SessionContent,
    StepTitle,
    OrderItems
  },
  props: {
    input: Object
  },
  data: function() {
    return {
      displayState: StatusDisplayState.status,
      StatusDisplayState,
      slide: 0,
      items: [],
      returnLabelText: null,
      returnQRCodeText: null
    }
  },
  computed: {
    ...mapState(['session', 'popupDisplayState']),
    ...mapGetters(['isLastItem']),
    canGoBack: function() {
      return this.session && this.session.can_undo
    }
  },
  methods: {
    done: function() {
      this.$emit('done') // we're done with the item status view, move on to the next step
    },
    goBack: function() {
      if (this.displayState === StatusDisplayState.status) {
        this.$emit('back') // we're viewing the status of the input action, go back to the previous page
      } else {
        this.displayState = StatusDisplayState.status // we're viewing the selected item details, go back to status
      }
    },
    setDisplayState: function(displayState) {
      if (this.session && this.session.is_popup) {
        this.$store.commit('set_display_state', StatusDisplayState.itemDetails)
      }
      this.displayState = displayState
    },
    editItem: function(input, item) {
      this.$emit('edit', input, item)
    },
    hideInputTypeButton: function(input) {
      // if input is scheduled on editor, we need to hide the button from the editor content
      setTimeout(() => {
        const elementFromEditor = document.querySelector("[inputtype='" + input.type + "']")
        if (elementFromEditor) {
          elementFromEditor.style.display = 'none'
        }
      }, 100)
    },
    processAdditionalInputs: function() {
      this.session.additional_inputs.forEach(input => {
        if (input.type === InputType.ShipmentReturnLabel) {
          this.returnLabelText = input.formatted_label
          this.hideInputTypeButton(input)
        } else if (input.type === InputType.ShipmentReturnQRCode) {
          this.returnQRCodeText = input.formatted_label
          this.hideInputTypeButton(input)
        }
      })
    },
    getShipmentReturnLabel: function(qrCode) {
      if (this.session.selected_item) {
        this.$store.commit('busy')
        this.$store.dispatch('load_shipment_return_label',
          {item: this.session.selected_item, qr_code: qrCode})
      }
    }
  },
  destroyed() {
    if (this.popupDisplayState) {
      this.$store.commit('set_display_state', StatusDisplayState.destroyed)
    }
  },
  created() {
    this.items = [this.session.selected_item]

    if (this.session.new_item) {
      this.items.push(this.session.new_item)
    }

    if (this.popupDisplayState) {
      this.displayState = this.popupDisplayState
    }

    if (this.session.additional_inputs) {
      this.processAdditionalInputs()
    }
  }
}
</script>

<style scoped>

</style>
